import React, { useCallback, useState } from 'react';
import Switch from '../Wizard/Switch';
import ParcelFinderContainer from '../parcel-finder/ParcelFinderContainer';
import ClaimsCenterOverview from './ClaimsCenterOverview';
import ClaimsCenterEmptyOverview from './ClaimsCenterEmptyOverview';
import Loader from '../common/Loader/Loader';
import Heading2 from '../common/Heading2';
import useClaimsStats from './useClaimsStats';
import SubmitClaimPanel from './submit-claims/SubmitClaimPanel';
import useClaimsCenterSearchOptions from './useClaimsCenterSearchOptions';
import useClaimsCounts from './useClaimsCounts';
import { useClaimsShopCarriers } from '../parcel-finder/claims/common/useClaimsShopCarriers';

function getSelected(claimsStats, loading, error) {
  if (loading) {
    return 'loading';
  }

  if (error) {
    return 'error';
  }

  if (claimsStats?.totalCount > 0) {
    return 'overview';
  }

  return 'empty';
}

function ClaimsCenterPage(props) {
  const { claimsStats, statusCounts, isStatsLoading, statsError, reloadClaimsStats } = useClaimsStats();
  const { claimsCounts, isLoading: isCountsLoading } = useClaimsCounts();
  const { data: shopCarriers = [], isLoading: isCarriersLoading } = useClaimsShopCarriers();

  const { searchFilters, setSearchFilters, sortBy, setSortBy, sortDir, setSortDir } = useClaimsCenterSearchOptions();
  const [submitClaimState, setSubmitClaimState] = useState({ isPanelOpen: false, draftId: null });

  const onStartClaimSubmission = useCallback(() => setSubmitClaimState({ isPanelOpen: true, draftId: null }), [
    setSubmitClaimState,
  ]);

  const onCloseClaimSubmission = useCallback(() => setSubmitClaimState({ isPanelOpen: false, draftId: null }), [
    setSubmitClaimState,
  ]);

  const onContinueClaimSubmission = useCallback(
    (claim) => setSubmitClaimState({ isPanelOpen: true, draftId: claim.id }),
    [setSubmitClaimState]
  );

  return (
    <ParcelFinderContainer {...props}>
      <Switch selected={getSelected(claimsStats, isStatsLoading, statsError)}>
        <Loader key="loading" />
        <ClaimsCenterEmptyOverview key="empty" showSidePanel={onStartClaimSubmission} />
        <ClaimsCenterOverview
          key="overview"
          claimsStats={claimsStats}
          claimsCounts={claimsCounts}
          statusCounts={statusCounts}
          isStatsLoading={isStatsLoading}
          shopCarriers={shopCarriers}
          isFiltersLoading={isCountsLoading || isCarriersLoading}
          statsError={statsError}
          reloadClaimsStats={reloadClaimsStats}
          onStartClaimSubmission={onStartClaimSubmission}
          onContinueClaimSubmission={onContinueClaimSubmission}
          searchFilters={searchFilters}
          setSearchFilters={setSearchFilters}
          sortBy={sortBy}
          setSortBy={setSortBy}
          sortDir={sortDir}
          setSortDir={setSortDir}
        />
        <Heading2 key="error">Error loading claims</Heading2>
      </Switch>
      <SubmitClaimPanel
        entryPoint="claims-center"
        isOpen={submitClaimState.isPanelOpen}
        draftId={submitClaimState.draftId}
        onClose={onCloseClaimSubmission}
        onClaimSubmitted={reloadClaimsStats}
      />
    </ParcelFinderContainer>
  );
}

export default ClaimsCenterPage;
